import { HistoryOutlined } from "@ant-design/icons";
import { Empty, Space, Table, Tag } from "antd";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { RecipeTab } from "./constants.ts";
import { useRecipe } from "./RecipeContext.tsx";
import { routes } from "../../routes.ts";
import type { RecipeDetailFragment } from "../../gql/generated/graphqlSchema.tsx";

type ParentRow = NonNullable<RecipeDetailFragment["usedAsSubRecipeIn"]>[number];

export const RecipeUsedAsSubRecipeTab = () => {
  const { t } = useTranslation();
  const { recipe } = useRecipe();
  const rows = recipe.usedAsSubRecipeIn;

  return (
    <Table<ParentRow>
      columns={[
        {
          title: t("recipes.name"),
          key: "name",
          render: (_, row) => (
            <Space>
              <Link to={{ pathname: routes.recipeDetail.to(row.recipe.id), hash: RecipeTab.Ingredients }}>
                {row.recipe.name}
              </Link>
              {row.isOutdated ? (
                <Tag color="warning" icon={<HistoryOutlined />}>
                  {t("recipes.parentOutdated")}
                </Tag>
              ) : null}
            </Space>
          ),
        },
      ]}
      dataSource={rows}
      locale={{ emptyText: <Empty description={t("recipes.usedAsSubRecipeEmpty")} /> }}
      pagination={false}
      rowKey={(row) => row.recipe.id}
      size="small"
    />
  );
};
